import axios from "axios";
import { BASE_URL } from "../../../variables";

export const getTerritoryApi = async ({ UserSH_Code__c, Title }) => {
  let url;
  if (Title === "SH6") {
    url = `${BASE_URL}/services/data/v56.0/query?q=Select id , SH2_Code__c, SH2_Name__c ,SH3_Code__c,SH6_Code__c from Pidilite_Hierarchy__c where SH6_Code__c ='${UserSH_Code__c}' AND RecordType.Name In('Sales Hierarchy','Key Information')`;
  } else if (Title === "SH5") {
    url = `${BASE_URL}/services/data/v56.0/query?q=Select id , SH2_Code__c, SH2_Name__c ,SH3_Code__c,SH6_Code__c from Pidilite_Hierarchy__c where SH5_Code__c ='${UserSH_Code__c}' AND RecordType.Name In('Sales Hierarchy','Key Information')`;
  } else if (Title === "SH7" || Title === "HO Collaborator" || Title === "TMM" || Title === "HO Auditor") {
    url = `${BASE_URL}/services/data/v56.0/query?q=Select id , SH2_Code__c, SH2_Name__c ,SH3_Code__c,SH6_Code__c,SH7_Code__c from Pidilite_Hierarchy__c where SH7_Code__c in (${UserSH_Code__c}) AND RecordType.Name In('Sales Hierarchy','Key Information')`;
  } else if (Title === "MH3" || Title === "RBDM Collaborator") {
    url = `${BASE_URL}/services/data/v56.0/query?q=SELECT Id, Name, CWP_User__c, Updated_by_DW__c, LastModifiedDate, SH2_Code__c, SH2_Name__c, SH2_Email__c, SH3_Code__c, SH3_Name__c, SH3_Email__c, SH4_Code__c, SH4_Email__c, SH5_Code__c, SH5_Email__c, SH6_Code__c, SH6_Email__c, SH7_Code__c, SH7_Email__c, TXNType__c FROM Pidilite_Hierarchy__c WHERE RecordType.Name = 'Sales Hierarchy' AND SH3_Code__c IN (${UserSH_Code__c}) AND Updated_by_DW__c = '1'`;
  } else if (Title === "SH4") {
    url = `${BASE_URL}/services/data/v56.0/query?q=Select id , SH2_Code__c, SH2_Name__c ,SH3_Code__c,SH6_Code__c,SH7_Code__c from Pidilite_Hierarchy__c where SH4_Code__c ='${UserSH_Code__c}' AND RecordType.Name In('Sales Hierarchy','Key Information')`;
  } else {
    url = `${BASE_URL}/services/data/v56.0/query?q=select id , SH2_Code__c, SH2_Name__c ,SH3_Code__c,TXNType__c,SH6_Code__c,SH3_Name__c  from Pidilite_Hierarchy__c where SH3_Code__c ='${UserSH_Code__c}' AND RecordType.Name In('Sales Hierarchy','Key Information')`;
  }
  const options = {
    url: url,
    method: "get",
  };
  try {
    const response = await axios(options);
    if (response.status === 200) {
      return {
        success: true,
        data: response?.data,
      };
    } else {
      throw Error("Something Went Wrong..!!");
    }
  } catch (err) {
    return {
      success: false,
      msg: "Somthing Went Wrong..!!",
    };
  }
};
